import request from '@/utils/request'

//门票信息
export function visitInfo(data) {
    return request({
      url: `/Exhibition/GetMemberVisitInfoByMobile`,
      method: 'post',
      data
    })
}

//预登记信息（以前记录）
export function beforeInfo(data) {
    return request({
      url: `/Exhibition/GetBeforeExhibitionVisitInfo`,
      method: 'post',
      data,
      isHasErrorOther: true
    })
}

//职业列表
export function dutyList(data) {
  return request({
    url: `/Exhibition/GetVisitMemberDutyList`,
    method: 'post',
    data
  })
}

//问卷列表
export function questionList(data) {
    return request({
      url: `/Exhibition/GetGymfQuestionList`,
      method: 'post',
      data
    })
}

//资料验证
export function checkInfo(data) {
    return request({
      url: `/Exhibition/CheckExhibitionVisitInfo`,
      method: 'post',
      data
    })
}

//添加预登记信息
export function addRecords(data) {
    return request({
      url: `/Exhibition/AddExhibitionVisitRecords`,
      method: 'post',
      data,
      isHasErrorOther: true
    })
}

//渠道访问次数
export function addViews(data) {
  return request({
    url: `/Exhibition/AddExhibitionVisitChannelViews`,
    method: 'post',
    data,
    isHasErrorOther: true
  })
}

// 公司联想数据
export function getQueryEnterpriseName(data) {
  return request({
    url: `/Exhibition/GetQueryEnterpriseName`,
    method: 'post',
    data,
    isHasErrorOther: true
  })
}

//获取预登记相关信息（证件类型、职位性质）
export function getApiInfo(data) {
  return request({
    url: `/Exhibition/NewGymfApiInfo`,
    method: 'post',
    data
  })
}

// 获取地区数据
export function getApiArea(data) {
  return request({
    url: `/Exhibition/NewGymfApiArea`,
    method: 'post',
    data,
    isHasErrorOther: true
  })
}

// 获取邮箱验证码
export function sendEmailCode(data) {
  return request({
    url: `/Exhibition/SendEmailCode`,
    method: 'post',
    data
  })
}